<template>
  <TheTermsAndConditions :to="{ name: 'depositsCryptoSteps' }" />
</template>

<script>
import TheTermsAndConditions from '@/components/account/blocks/TheTermsAndConditions'

export default {
  name: 'CRYPTOTermsAndConditions',
  components: {
    TheTermsAndConditions,
  },
}
</script>
